var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallActivityArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 5,
    viewBox: "0 0 12 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6525 2.33084C11.6292 2.27834 11.6 2.23167 11.5592 2.19084L9.80917 0.44084C9.64 0.271673 9.36 0.271673 9.19083 0.44084C9.02167 0.610006 9.02167 0.890006 9.19083 1.05917L10.1942 2.06251H0.75C0.510833 2.06251 0.3125 2.26084 0.3125 2.50001C0.3125 2.73917 0.510833 2.93751 0.75 2.93751H10.1942L9.19083 3.94084C9.02167 4.11001 9.02167 4.39001 9.19083 4.55917C9.27833 4.64667 9.38917 4.68751 9.5 4.68751C9.61083 4.68751 9.72167 4.64667 9.80917 4.55917L11.5592 2.80917C11.6 2.76834 11.6292 2.72167 11.6525 2.66917C11.6992 2.56417 11.6992 2.44167 11.6525 2.33667V2.33084Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallActivityArrow);
export default __webpack_public_path__ + "static/media/small-activity-arrow.997e64c6424538bf8402211072227893.svg";
export { ForwardRef as ReactComponent };